import PagesList from './PagesList'
import { ReactComponent as CategoryClosedIcon } from 'assets/images/icons/category closed.svg'
import { ReactComponent as CategoryOpenedIcon } from 'assets/images/icons/category opend.svg'
import { ReactComponent as MenuIcon } from 'assets/images/icons/menu.svg'
import { checkUser_for_admin_or_owner, checkUser_for_admin_or_owner_or_editor } from 'utils/helpers'
import { MoreButton } from 'modules/app/styles'
import { DropdownItem, DropdownMenu, DropdownToggle } from 'reactstrap'
import { CustomButton } from 'modules/auth/styles'
import { AccordionItemButton, AccordionItemHeading, AccordionItemPanel, AccordionItemState } from 'react-accessible-accordion'
import { Link } from 'react-router-dom'
import { AccordionItemStyled } from 'modules/mainmenu/responses/styles'
import { ReactComponent as ExpandedOff } from 'assets/images/icons/expander_off.svg'
import { ReactComponent as ExpandedOn } from 'assets/images/icons/expander_on.svg'
import { ReactComponent as PrivateIcon } from 'assets/images/icons/private.svg'
import { EmptyListCreateDraft } from './EmptyListCreateDraft'
import { drageAndDropPublishedContent_api } from 'store/apis'
import { history } from 'store/store'
import { Fragment } from 'react'
import { connect } from 'react-redux'
import { getContents_action, getPrivateAndFavoriteContents_action, toggleCategoryModal_action, toggleDeleteCategoryModal_action } from 'store/actions'
import { useLocation } from 'react-router-dom'

export function AccordionCustom(props) {
    const { pathname } = useLocation();

  const getCurrentCategoryFromUrl = () => {
    const urlToArray = pathname?.split('/');
    return urlToArray[urlToArray.length - 1]
  }

  return (
    <Fragment>
      {props.categories
        .filter((cat) => cat.id !== null)
        .map((cat, i) => (
          <Fragment key={i}>
            <AccordionItemStyled uuid={`cat_${cat.uuid}`} id={`cat-${cat.id}-${cat.uuid}`} className={`categorySection accordionItem ${props.isChild && 'child'}`} level={0}>
              <AccordionItemHeading
                className='accordionItemHeading'
                onDragOver={(e) => {
                  e.preventDefault()
                  const categorySection = e.target.closest('.categorySection')
                  if (categorySection) categorySection.classList.add('is-dragging-hover')
                }}
                onDragLeave={(e) => {
                  const categorySection = e.target.closest('.categorySection')
                  if (categorySection) categorySection.classList.remove('is-dragging-hover')
                }}
                onDrop={async (e) => {
                  e.stopPropagation()
                  const categorySection = e.target.closest('.categorySection')
                  categorySection.classList.remove('is-dragging-hover')
                  const id = parseInt(categorySection.id.split('-')[1])
                  const dragingPage = JSON.parse(e.dataTransfer.getData('dragingPage'))
                  if (dragingPage.section === props.section && categorySection && dragingPage.category_id !== id) {
                    await drageAndDropPublishedContent_api({ category_id: id }, dragingPage.uuid)
                    if (dragingPage.category?.uuid) {
                      props.getContents({ type: dragingPage.type, category_uuid: dragingPage.category?.uuid })
                    } else {
                      props.getPrivateAndFavoriteContents({ type: dragingPage.type })
                    }
                    props.getContents({ type: cat.type, category_uuid: cat.uuid })
                  }
                }}>
                <AccordionItemButton className='accordionItemButton d-flex justify-content-between'>
                  <AccordionItemState>
                    {({ expanded }) => (
                      <div className='categoryName-wrapper' onClick={() => !expanded && !props.searchText && props.getContents({ type: cat.type, category_uuid: cat.uuid })}>
                        {expanded ? (
                          <div className='expandButton expanded'>
                            <ExpandedOn />
                          </div>
                        ) : (
                          <div className='expandButton'>
                            <ExpandedOff />
                          </div>
                        )}

                        <Link className={`categoryName ml-1 mr-3 ${cat?.uuid === getCurrentCategoryFromUrl() ? 'active' : ''}`} to={`/page/category/${cat.uuid}`} onClick={(e) => e.stopPropagation()}>
                          {!props.isPrivate && <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>}
                          {props.isPrivate && <PrivateIcon />}
                          <span className='ml-2'> {cat.name} </span>
                        </Link>
                      </div>
                    )}
                  </AccordionItemState>

                  {/* Action Dropdown */}
                  {checkUser_for_admin_or_owner_or_editor(cat, props.user) && (
                    <MoreButton className='more-button-dropdown' direction='left' onClick={(e) => e.stopPropagation()}>
                      <DropdownToggle caret={false} tag='div'>
                        <CustomButton type='button' className='toggle shadow-none'>
                          <MenuIcon />
                        </CustomButton>
                      </DropdownToggle>
                      <DropdownMenu>
                        <DropdownItem className='border-bottom' onClick={() => history.push(`/pages/drafts/create?category=${cat.uuid}`)}>
                          Create a draft
                        </DropdownItem>
                        <DropdownItem className='border-bottom' onClick={() => props.toggleCategoryModal(true, { parent_id: cat.id, parent_category: cat, root_category: cat, type: 'page' })}>
                          Add subcategory
                        </DropdownItem>
                        {checkUser_for_admin_or_owner(cat, props.user) && (
                          <>
                            <DropdownItem className='border-bottom' onClick={() => props.toggleCategoryModal(true, { ...cat, root_category: null })}>
                              Settings
                            </DropdownItem>
                            <DropdownItem className='border-bottom text-danger' onClick={() => props.toggleDeleteCategoryModal(true, cat)}>
                              Delete
                            </DropdownItem>
                          </>
                        )}
                      </DropdownMenu>
                    </MoreButton>
                  )}
                </AccordionItemButton>
              </AccordionItemHeading>
              <AccordionItemPanel className={`AccordionItemPanel pages ${cat.subcategories.length > 0 ? 'noline pt-0' : ''}`}>
                {/* Level 1 */}
                {/* <Accordion allowMultipleExpanded allowZeroExpanded preExpanded={props.preExpanded}> */}
                {cat.subcategories.map((sub_cat, i) => (
                  <Fragment key={i}>
                    <AccordionItemStyled uuid={`cat_${sub_cat.uuid}`} id={`cat-${sub_cat.id}-${sub_cat.uuid}`} className='categorySection accordionItem child' key={i} level={props.isChild ? 2 : 1}>
                      {/* Level 1 Heading */}
                      <AccordionItemHeading
                        className='accordionItemHeading'
                        onDragOver={(e) => {
                          e.preventDefault()
                          const categorySection = e.target.closest('.categorySection')
                          if (categorySection) categorySection.classList.add('is-dragging-hover')
                        }}
                        onDragLeave={(e) => {
                          const categorySection = e.target.closest('.categorySection')
                          if (categorySection) categorySection.classList.remove('is-dragging-hover')
                        }}
                        onDrop={async (e) => {
                          e.stopPropagation()
                          const categorySection = e.target.closest('.categorySection')
                          categorySection.classList.remove('is-dragging-hover')
                          const id = parseInt(categorySection.id.split('-')[1])
                          const dragingPage = JSON.parse(e.dataTransfer.getData('dragingPage'))
                          if (dragingPage.section === props.section && categorySection && dragingPage.category_id !== id) {
                            await drageAndDropPublishedContent_api({ category_id: id }, dragingPage.uuid)
                            if (dragingPage.category?.uuid) {
                              props.getContents({ category_uuid: dragingPage.category?.uuid, type: dragingPage.type })
                            } else {
                              props.getPrivateAndFavoriteContents({ type: dragingPage.type })
                            }
                            props.getContents({ type: sub_cat.type, category_uuid: sub_cat.uuid })
                          }
                        }}>
                        <AccordionItemButton className='accordionItemButton d-flex justify-content-between'>
                          <AccordionItemState>
                            {({ expanded }) => (
                              <div className='categoryName-wrapper' onClick={() => !expanded && !props.searchText && props.getContents({ type: sub_cat.type, category_uuid: sub_cat.uuid })}>
                                {expanded ? (
                                  <div className='expandButton expanded'>
                                    <ExpandedOn />
                                  </div>
                                ) : (
                                  <div className='expandButton'>
                                    <ExpandedOff />
                                  </div>
                                )}
                                <div className='categoryName ml-1 mr-3'>
                                  <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>
                                  <span className='ml-2'>{sub_cat.name}</span>
                                </div>
                              </div>
                            )}
                          </AccordionItemState>
                          {/* Action Dropdown */}
                          {checkUser_for_admin_or_owner_or_editor(cat, props.user) && (
                            <MoreButton className='more-button-dropdown' direction='left' onClick={(e) => e.stopPropagation()}>
                              <DropdownToggle caret={false} tag='div'>
                                <CustomButton type='button' className='toggle shadow-none'>
                                  <MenuIcon />
                                </CustomButton>
                              </DropdownToggle>
                              <DropdownMenu>
                                <DropdownItem className='border-bottom' onClick={() => history.push(`/pages/drafts/create?category=${sub_cat.uuid}`)}>
                                  Create a draft
                                </DropdownItem>
                                <DropdownItem
                                  className='border-bottom'
                                  onClick={() => props.toggleCategoryModal(true, { parent_id: sub_cat.id, parent_category: sub_cat, root_category: cat, type: 'page' })}>
                                  Add subcategory
                                </DropdownItem>

                                {checkUser_for_admin_or_owner(cat, props.user) && (
                                  <>
                                    <DropdownItem className='border-bottom' onClick={() => props.toggleCategoryModal(true, { ...sub_cat, root_category: cat })}>
                                      Settings
                                    </DropdownItem>
                                    <DropdownItem className='border-bottom text-danger' onClick={() => props.toggleDeleteCategoryModal(true, sub_cat)}>
                                      Delete
                                    </DropdownItem>
                                  </>
                                )}
                              </DropdownMenu>
                            </MoreButton>
                          )}
                        </AccordionItemButton>
                      </AccordionItemHeading>
                      {/* End.Level 1 Heading */}
                      <AccordionItemPanel className={`AccordionItemPanel pages ${sub_cat.subcategories.length > 0 ? 'noline pt-0' : ''}`}>
                        {/* Level 2 */}
                        {/* <Accordion allowMultipleExpanded allowZeroExpanded preExpanded={props.preExpanded}> */}
                        {sub_cat.subcategories.map((sub_sub_cat, i) => (
                          <Fragment key={i}>
                            <AccordionItemStyled uuid={`cat_${sub_sub_cat.uuid}`} id={`cat-${sub_sub_cat.id}-${sub_sub_cat.uuid}`} className='categorySection accordionItem child' key={i} level={1}>
                              {/* Level 2 Heading */}
                              <AccordionItemHeading
                                className='accordionItemHeading'
                                onDragOver={(e) => {
                                  e.preventDefault()
                                  const categorySection = e.target.closest('.categorySection')
                                  if (categorySection) categorySection.classList.add('is-dragging-hover')
                                }}
                                onDragLeave={(e) => {
                                  const categorySection = e.target.closest('.categorySection')
                                  if (categorySection) categorySection.classList.remove('is-dragging-hover')
                                }}
                                onDrop={async (e) => {
                                  e.stopPropagation()
                                  const categorySection = e.target.closest('.categorySection')
                                  categorySection.classList.remove('is-dragging-hover')
                                  const id = parseInt(categorySection.id.split('-')[1])
                                  const dragingPage = JSON.parse(e.dataTransfer.getData('dragingPage'))
                                  if (dragingPage.section === props.section && categorySection && dragingPage.category_id !== id) {
                                    await drageAndDropPublishedContent_api({ category_id: id }, dragingPage.uuid)
                                    if (dragingPage.category?.uuid) {
                                      props.getContents({ category_uuid: dragingPage.category?.uuid, type: dragingPage.type })
                                    } else {
                                      props.getPrivateAndFavoriteContents({ type: dragingPage.type })
                                    }
                                    props.getContents({ type: sub_sub_cat.type, category_uuid: sub_sub_cat.uuid })
                                  }
                                }}>
                                <AccordionItemButton className={`accordionItemButton d-flex justify-content-between`}>
                                  <AccordionItemState>
                                    {({ expanded }) => (
                                      <div
                                        className='categoryName-wrapper'
                                        onClick={() => !expanded && !props.searchText && props.getContents({ type: sub_sub_cat.type, category_uuid: sub_sub_cat.uuid })}>
                                        {expanded ? (
                                          <div className='expandButton expanded'>
                                            <ExpandedOn />
                                          </div>
                                        ) : (
                                          <div className='expandButton'>
                                            <ExpandedOff />
                                          </div>
                                        )}
                                        <div className='categoryName ml-1 mr-3'>
                                          <AccordionItemState>{({ expanded }) => (expanded ? <CategoryOpenedIcon /> : <CategoryClosedIcon />)}</AccordionItemState>
                                          <span className='ml-2'>{sub_sub_cat.name}</span>
                                        </div>
                                      </div>
                                    )}
                                  </AccordionItemState>

                                  {/* Action Dropdown */}
                                  {checkUser_for_admin_or_owner_or_editor(cat, props.user) && (
                                    <MoreButton className='more-button-dropdown' direction='left' onClick={(e) => e.stopPropagation()}>
                                      <DropdownToggle caret={false} tag='div'>
                                        <CustomButton type='button' className='toggle shadow-none'>
                                          <MenuIcon />
                                        </CustomButton>
                                      </DropdownToggle>
                                      <DropdownMenu>
                                        <DropdownItem className='border-bottom' onClick={() => history.push(`/pages/drafts/create?category=${sub_sub_cat.uuid}`)}>
                                          Create a draft
                                        </DropdownItem>
                                        {checkUser_for_admin_or_owner(cat, props.user) && (
                                          <>
                                            <DropdownItem className='border-bottom' onClick={() => props.toggleCategoryModal(true, { ...sub_sub_cat, root_category: cat })}>
                                              Settings
                                            </DropdownItem>
                                            <DropdownItem className='border-bottom text-danger' onClick={() => props.toggleDeleteCategoryModal(true, sub_sub_cat)}>
                                              Delete
                                            </DropdownItem>
                                          </>
                                        )}
                                      </DropdownMenu>
                                    </MoreButton>
                                  )}
                                </AccordionItemButton>
                              </AccordionItemHeading>
                              {/* End.Level 2 Heading */}
                              {/* Lavel 2 Pages */}
                              <AccordionItemPanel className={`AccordionItemPanel pages ${sub_sub_cat.subcategories.length > 0 ? 'noline pt-0' : ''}`}>
                                <PagesList
                                  category_uuid={sub_sub_cat.uuid}
                                  showMovetocategory={props.showMovetocategory}
                                  section={props.section}
                                  pages={sub_sub_cat.contents}
                                  level={sub_sub_cat.subcategories.length > 0 ? 1 : 2}
                                />
                                {!props.searchText && (
                                  <EmptyListCreateDraft type='page' hideAddDraftLink={props.hideAddDraftLink} level={sub_sub_cat.subcategories.length > 0 ? 1 : 2} category={sub_sub_cat} />
                                )}
                              </AccordionItemPanel>
                            </AccordionItemStyled>
                          </Fragment>
                        ))}
                        {/* </Accordion> */}
                        {/* End: Level 2 */}
                        {/* Level 1 Pages */}
                        <PagesList
                          category_uuid={sub_cat.uuid}
                          showMovetocategory={props.showMovetocategory}
                          section={props.section}
                          pages={sub_cat.contents}
                          level={sub_cat.subcategories.length > 0 ? 1 : 2}
                        />
                        {!props.searchText && <EmptyListCreateDraft type='page' hideAddDraftLink={props.hideAddDraftLink} level={sub_cat.subcategories.length > 0 ? 1 : 2} category={sub_cat} />}
                      </AccordionItemPanel>
                    </AccordionItemStyled>
                  </Fragment>
                ))}
                {/* </Accordion> */}
                {/* End: Level 1 */}
                {/* Lavel 0 Pages */}
                <PagesList
                  category_uuid={cat.uuid}
                  showMovetocategory={props.showMovetocategory}
                  section={props.section}
                  pages={cat.contents}
                  level={props.isChild ? (cat.subcategories.length > 0 ? 1 : 2) : 1}
                />
                {!props.searchText && <EmptyListCreateDraft type='page' hideAddDraftLink={props.hideAddDraftLink} level={1} category={cat} />}
              </AccordionItemPanel>
            </AccordionItemStyled>
          </Fragment>
        ))}
    </Fragment>
  )
}

const mapDispatchToProps = (dispatch) => ({
  toggleCategoryModal: (status, item) => dispatch(toggleCategoryModal_action(status, item)),
  toggleDeleteCategoryModal: (status, item, redirectToHome) => dispatch(toggleDeleteCategoryModal_action(status, item, redirectToHome)),
  getContents: (filters) => new Promise((resolve, reject) => dispatch(getContents_action(filters, resolve, reject))),
  getPrivateAndFavoriteContents: (filters) => dispatch(getPrivateAndFavoriteContents_action(filters))
})
const mapStateToProps = (state) => ({
  user: state.auth.user,
  location: state.router.location,
  selectedPageOrDraft: state.contents.selectedPageOrDraft
})
export default connect(mapStateToProps, mapDispatchToProps)(AccordionCustom)
